import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ChatMessage, Location } from "@/types";
import { AIService } from "@/services/chatService";
import { ChatHistory } from "@/types";

export const useChat = (tripId: string, selectedLocation: Location) => {
  const { data, isLoading, error } = useQuery<ChatHistory>({
    queryKey: [
      "chatHistory",
      tripId,
      selectedLocation?.waytora_id,
      selectedLocation?.id,
    ],
    queryFn: () => {
      if (!tripId || !selectedLocation?.waytora_id || !selectedLocation?.id) {
        return Promise.reject(new Error("Missing required parameters"));
      }
      return AIService.getChatHistory(
        tripId,
        selectedLocation.waytora_id,
        selectedLocation.id
      );
    },
    enabled: Boolean(
      tripId && selectedLocation?.waytora_id && selectedLocation?.id
    ),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return { data, isLoading, error };
};
